import { render, staticRenderFns } from "./TemplatePage.vue?vue&type=template&id=6e4fa41c&scoped=true&"
import script from "./TemplatePage.vue?vue&type=script&lang=js&"
export * from "./TemplatePage.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePage.vue?vue&type=style&index=0&id=6e4fa41c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4fa41c",
  null
  
)

export default component.exports